import { createFileRoute } from "@tanstack/react-router"

import { SettingsAccountNotificationsPage } from "@/pages/settings/account-notifications"

// Open to any authenticated user so viewers see this account-wide setting read-only (FLO-106).
// The page disables the controls without ACCOUNT_SETTINGS_UPDATE; the backend PATCH still enforces it.
export const Route = createFileRoute("/_authenticated/settings/account/notifications")({
  component: SettingsAccountNotificationsPage,
})
